module.exports = __webpack_public_path__ + "img/sind-die-lichter.9cde4bf1.jpeg";